import baseAPI from '../axiosApi'

const api={
    meetingApply:'/api-ir/meeting/arrange/apply',
    meetingTodo:'/api-ir/meeting/arrange/todo',
    sealApply:'/api-ir/office/seal/apply',
    sealTodo:'/api-ir/office/seal/todo',
}

export function meetingApply (data) {
    return baseAPI.axiosData(api.meetingApply,'get',data)
}

export function meetingTodo (data) {
    return baseAPI.axiosData(api.meetingTodo,'get',data)
}

export function sealApply (data) {
    return baseAPI.axiosData(api.sealApply,'get',data)
}

export function sealTodo (data) {
    return baseAPI.axiosData(api.sealTodo,'get',data)
}